import React, { useState } from "react";
import { useAppContext } from "../utils/context/app-context";
import { TextInput } from "../components/FormComponents";
import {
	Button,
	ContentContainer,
	TitleHeader,
	NarrowContentWrapper,
	AlertMessage,
} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper,
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";
import { useUserIsReadOnly } from "../components/userFunctions";

const CreateStudentPage = () => {
	const { api } = useAppContext();
	useDocumentTitle("Create Participant");
	const [student, setStudent] = useState({
		first_name: "",
		last_name: "",
		email: "",
	});
	const [updating, setUpdating] = useState(false);
	const [updated, setUpdated] = useState(false);
	const [validationErrors, setValidationErrors] = useState({});
	const [error, setError] = useState(null);
	let course = api.getCurrentCourse();
	let date = api.getCurrentDate();
	const isReadOnly = useUserIsReadOnly();

	async function handleSubmit(e) {
		e.preventDefault();
		setUpdating(true);
		setError(null);
		setValidationErrors({});
		setUpdated(false);

		// Validate form
		let errors = {};
		if (!student.first_name) {
			errors.first_name = "First Name is required";
		}
		if (!student.last_name) {
			errors.last_name = "Last Name is required";
		}

		if (Object.keys(errors).length) {
			setValidationErrors(errors);
			setUpdating(false);
			return;
		}

		const { data, error } = await api.fetchData(
			`/students`,
			"POST",
			{
				course_id: course.id,
				date_id: date.id,
				first_name: student.first_name,
				last_name: student.last_name,
				email: student.email,
			}
		);

		if (data?.success) {
			setUpdating(false);
			setUpdated(true);
		} else {
			setError(error || data?.error || "An error occurred")
			setUpdating(false);
		}
	}

	function updateField(name, value) {
		setStudent({
			...student,
			[name]: value,
		});
	}

	return (
		<div className="edit-student-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title="Add New Participant" />
					<NarrowContentWrapper>
						<div className="edit-student-form">
							<form action="">
								<div className="form-row">
									<div className="col-sm-6">
										<TextInput
											label="First Name"
											name="first_name"
											value={student.first_name}
											onChange={(e) => {
												updateField(
													"first_name",
													e.target.value
												);
											}}
											required={true}
											error={validationErrors?.first_name}
										/>
									</div>
									<div className="col-sm-6">
										<TextInput
											label="Last Name"
											name="last_name"
											value={student.last_name}
											onChange={(e) => {
												updateField(
													"last_name",
													e.target.value
												);
											}}
											required={true}
											error={validationErrors?.last_name}
										/>
									</div>
								</div>
								<TextInput
									label="Email Address"
									name="email"
									type="email"
									value={student.email}
									onChange={(e) => {
										updateField("email", e.target.value);
									}}
									error={validationErrors?.email}
								/>
								{error && (
									<AlertMessage
										type="danger"
										message={error}
									/>
								)}
								{updated && (
									<AlertMessage
										type="success"
										message="Participant Created"
									/>
								)}
								{!updated && (
									<Button
										text={
											updating
												? "Creating Participant..."
												: "Create Participant"
										}
										type="primary"
										onClick={handleSubmit}
										disabled={updating || isReadOnly}
										className="mt-3"
									/>
								)}
							</form>
						</div>
					</NarrowContentWrapper>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
};

export default CreateStudentPage;
